export default __webpack_public_path__ + "static/media/hotelfc_cover.a0eb957f.jpg";